import styled from 'styled-components';

const RequestContent = styled.div`
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default RequestContent;
